module.exports = __webpack_public_path__ + "static/bannerPoly-063a34fe3a564027f1e4334edbe918ec.png";